import { Component, OnInit ,Input} from '@angular/core';

@Component({
  selector: 'app-plandetail-currentplan',
  templateUrl: './plandetail-currentplan.component.html',
  styleUrls: ['./plandetail-currentplan.component.sass']
})
export class PlandetailCurrentplanComponent implements OnInit {

  @Input() yz;
  @Input() plazo_equipo;
  @Input() serv_ad;
  @Input() valor_de_plan;
  @Input() descr_plan;
  @Input() type_plan;
  @Input() ins_eq;
  constructor() { }

  ngOnInit() {
  }

}
